import React, { useState, useRef } from "react";
import EmojiPicker from "emoji-picker-react";
import { Theme } from "emoji-picker-react";
import "./index.css"
import useAppAccessor from "../../../../hooks/useappAccessor";
import { setIn } from "formik";
import { SEND_BTN } from "../../../../assets/icons";

interface ChatboxProps {
  sendMessage: Function;
  onChangeText: Function;
  textValue: string;
  isChatOn: boolean;
  onInputFocus?: () => void;
  onInputBlur?: () => void;
}

const Chatbox: React.FC<ChatboxProps> = ({
  sendMessage,
  textValue,
  onChangeText,
  isChatOn,
  onInputFocus,
  onInputBlur
}) => {
  const [chosenEmojis, setChosenEmojis] = useState<string[]>([]);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [inputMessage, setInputMessage] = useState("");
  const { getUserData } = useAppAccessor();
  const { language } = getUserData();
  const isMobile =
    window.innerWidth < 768 ||
    /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent);

  const inputRef = useRef<HTMLTextAreaElement>(null);
  const darkThemeValue: Theme = Theme.DARK;
  const date = new Date();

  const handleEmojiClick = (emojiObject: { emoji: string }) => {
    const emoji = emojiObject?.emoji;
    const cursorPosition = inputRef.current?.selectionStart;

    if (cursorPosition !== undefined && inputRef.current !== null) {
      const textBeforeCursor = textValue.substring(0, cursorPosition);
      const textAfterCursor = textValue.substring(cursorPosition);

      const newText = textBeforeCursor + emoji + textAfterCursor;

      // Update the textValue state in the parent component
      onChangeText(newText);

      const newCursorPosition = cursorPosition + emoji.length;
      inputRef.current.selectionStart = newCursorPosition;
      inputRef.current.selectionEnd = newCursorPosition;
    }

    setShowEmojiPicker(false);
  };

  // const handleSendMessage = () => {
  //   if (textValue.trim() !== "") {
  //     const newMessage = { text: textValue, emojis: chosenEmojis, createAt: date.toLocaleTimeString([], {timeStyle: 'short'}) };
  //     sendMessage(newMessage);
  //     setInputMessage("");
  //     setChosenEmojis([]);
  //   }
  // };

  return (
    <div className="chatbox--input flex rounded-bl rounded-br  h-full w-full items-center justify-center">
      <textarea
        disabled={!isChatOn ? true : false}
        ref={inputRef}
        value={textValue}
        onChange={(e) => {
          setInputMessage(e.target.value);
          onChangeText(e.target.value);
        }}
        onFocus={() => {
          if (isMobile) onInputFocus?.();
        }}
        onBlur={(e) => {
          if (isMobile) onInputBlur?.();
          if (e.target instanceof HTMLElement) {
            e.target.blur();
          }
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            setInputMessage("");
            sendMessage(e);
            if (e.target instanceof HTMLElement) {
              e.target.blur();
            }
            setTimeout(() => {
              window.scrollTo(0, 0);
            }, 100);
          }
        }}
        placeholder={"What's on your mind?"}
        style={{background:'transparent'}}
        className="resize-none outline-none text-sm flex text-white rounded-br w-full h-full pt-[18px] pl-2 rounded-bl textarea-placeholder"
      ></textarea>
      
      { inputMessage.length > 0 && <div
        onClick={(e) => {
          sendMessage(inputMessage);
          setInputMessage("");
        }}
        style={{ position: 'relative', zIndex: 100, pointerEvents: 'auto', cursor: "pointer" , color: 'white', backgroundColor: '#222324', padding: '4px 10px', borderRadius: '8px', marginRight: '5px'}}
        className="flex items-center justify-center">
          <img style={{ height: 24, width: 24 }} src={SEND_BTN}></img>
        </div>
        }
      {(showEmojiPicker && isChatOn) && (
        <>
          {!isMobile ? (
            <div className="fixed mt-8 mr-32 top-2/3 right-2/4 transform -translate-x-1/2 -translate-y-1/2 p-4 rounded-lg shadow-md">
              <EmojiPicker
                theme={darkThemeValue}
                onEmojiClick={handleEmojiClick}
              />
            </div>
          ) : (
            <div className="absolute bottom-0 mb-20 rounded-lg shadow-md">
              <EmojiPicker
                theme={darkThemeValue}
                onEmojiClick={handleEmojiClick}
              />
            </div>
          )}
        </>
      )}
      {
        !isMobile && (
          <div
        onClick={() => setShowEmojiPicker(!showEmojiPicker)}
        className="flex items-center justify-center"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="white"
          className=" mr-2  items-center"
          style={{ cursor: "pointer", height: 24, width: 24 }}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M15.182 15.182a4.5 4.5 0 01-6.364 0M21 12a9 9 0 11-18 0 9 9 0 0118 0zM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75zm-.375 0h.008v.015h-.008V9.75zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75zm-.375 0h.008v.015h-.008V9.75z"
          />
        </svg>
      </div>
        )
      }
      
    </div>
  );
};

export default Chatbox;
